<button mat-icon-button class="closer" [mat-dialog-close]="">
  <mat-icon mat-list-icon>close</mat-icon>
</button>
<h1 mat-dialog-title>Template Editor</h1>
<div mat-dialog-content>


  <!-- If the user is not part of the template manager group, then they can't edit global or public templates -->
  @if(!isAdmin && (myForm.controls['publicView'].value || myForm.controls['globalView'].value)) {

  <div class="template-name-display"> {{myForm.controls['templateViewName'].value}}</div>
 
  }@else {

  <form [formGroup]="myForm" (keydown.enter)="$event.preventDefault()">
    <mat-form-field class="full-width">
      <input matInput [formControl]="myForm.controls['templateViewName']" placeholder="Template Name"
        [disabled]="!isDefault">
    </mat-form-field>
    @if (isAdmin) {
    <div class="checkbox-selection">
      <mat-checkbox [formControl]="myForm.controls['publicView']">Share View?</mat-checkbox>
      <mat-checkbox [formControl]="myForm.controls['globalView']">Make Global</mat-checkbox>
    </div>
    }

  </form>

  }



</div>
@if(!isAdmin && (myForm.controls['publicView'].value || myForm.controls['globalView'].value)) {
  <div class="permission-notice">
    <mat-icon>lock</mat-icon>
    <div>
      <strong>Permission Required to Edit Shared or Global Templates</strong>
      <p>Contact your administrator to be added to the
        <em>Template Manager</em> group to make changes.</p>
    </div>
  </div>
}@else {

<div class="dialog-actions" mat-dialog-actions>
  <button mat-raised-button color="warn" (click)="btnDelete()">Delete</button>
  @if(overWrite){
  <button mat-raised-button color="accent" (click)="btnSaveAs()">Save As</button>
  <button mat-raised-button color="primary" (click)="btnSave()">Update</button>
  }
  @if(!overWrite){
  <button mat-raised-button color="primary" (click)="btnSave()">Save</button>
  }

</div>

}